@if (!(loading | async)) {
  <div>
    @if (!!unMappedLossCause) {
      <div class="row">
        <div class="column twelve pad-bottom-10">
          <h4
            class="heading-sub-section margin-0 margin-bottom-20"
            dsContent
            [contentPath]="'claims.fnol.lossCauseSectionHeading'"
          ></h4>
          <p>{{ unMappedLossCause }}</p>
          <div class="row callToAction">
            <a
              href="javascript:void(0)"
              (click)="goBackOneStep()"
              class="float-right md-float-left caption"
            >
              <i class="icon-chevron-left"></i> Back</a
            >
            <span class="md-float-right">
              <a
                class="pad-horizontal-20"
                (click)="cancel()"
                dsContent
                [contentPath]="'shared.cancel'"
              ></a>
              <button
                ds-button
                type="submit"
                data-cy="primaryButton"
                (click)="submitUnMappedLossCause()"
              >
                {{
                  !!this.draftClaim && !!this.draftClaim?.lossCause
                    ? 'Save updates'
                    : 'Save and Continue'
                }}
              </button>
            </span>
          </div>
        </div>
      </div>
    }
    @if (!unMappedLossCause) {
      <form [formGroup]="lossCauseForm" (ngSubmit)="submitLossCause()">
        <section formGroupName="cause">
          <div class="row">
            <div class="column twelve pad-bottom-10">
              <h4
                class="heading-sub-section"
                dsContent
                [contentPath]="'claims.fnol.lossCauseSectionHeading'"
              ></h4>
            </div>
            <div class="column twelve md-five">
              <ds-form-control-container labelText="Cause" [control]="causeGroup.get('lossCause')">
                <select
                  id="lossCause"
                  class="icon fill"
                  formControlName="lossCause"
                  (change)="changeLossCause($event.target.value)"
                >
                  <option value=""></option>
                  @for (lossCause of lossCauses; track lossCause) {
                    <option [value]="lossCause.value">
                      {{ lossCause.name }}
                    </option>
                  }
                </select>
                <span class="icon-chevron-down"></span>
                <ds-form-control-message
                  [control]="causeGroup.get('lossCause')"
                ></ds-form-control-message>
              </ds-form-control-container>
            </div>
          </div>
          <!-- loss cause of type Collision -->
          @if (lossCause?.value === 'COLLISION') {
            <div class="row">
              <div class="column twelve pad-top-40 pad-bottom-10">
                <h4
                  class="heading-sub-section"
                  dsContent
                  [contentPath]="'claims.fnol.collisionMovingObjectOrVehicle'"
                ></h4>
              </div>
              <div class="column twelve">
                <fieldset class="radio">
                  <div class="flex items-center">
                    <input
                      class="margin-right-6"
                      type="radio"
                      formControlName="collisionStationary"
                      id="collisionStationary-yes"
                      [value]="'yes'"
                    />
                    <label
                      for="collisionStationary-yes"
                      dsContent
                      [contentPath]="'claims.fnol.yesMovingObjectOrVehicle'"
                    >
                    </label>
                  </div>
                  <div class="flex items-center pad-top-10">
                    <input
                      class="margin-right-6"
                      type="radio"
                      formControlName="collisionStationary"
                      id="collisionStationary-no"
                      [value]="'no'"
                    />
                    <label
                      for="collisionStationary-no"
                      dsContent
                      [contentPath]="'claims.fnol.noMovingObjectOrVehicle'"
                    >
                    </label>
                  </div>
                </fieldset>
              </div>
              <div class="column twelve pad-top-40 pad-bottom-10">
                <h4
                  class="heading-sub-section"
                  dsContent
                  [contentPath]="'claims.fnol.vehicleDamageTypeHeading'"
                ></h4>
              </div>
              <div class="column twelve md-five">
                <ds-form-control-container
                  labelText="Details"
                  [control]="causeGroup.get('collisionLoss')"
                >
                  <select id="collisionLoss" class="icon fill" formControlName="collisionLoss">
                    <option value=""></option>
                    @for (detail of collisionDetailCauses; track detail) {
                      <option [value]="detail.value">
                        {{ detail.name }}
                      </option>
                    }</select
                  ><span class="icon-chevron-down"></span>
                  <ds-form-control-message
                    [control]="causeGroup.get('collisionLoss')"
                  ></ds-form-control-message>
                </ds-form-control-container>
              </div>
            </div>
          }
          <!-- loss cause of type Theft-Vandalism -->
          @if (lossCause?.value === 'THEFT') {
            <div class="row">
              <div class="column twelve pad-top-40 pad-bottom-10">
                <h4
                  class="heading-sub-section"
                  dsContent
                  [contentPath]="'claims.fnol.theftDamageTypeHeading'"
                ></h4>
              </div>
              <div class="column twelve md-five">
                <ds-form-control-container
                  labelText="Details"
                  [control]="causeGroup.get('theftLoss')"
                >
                  <select id="theftLoss" class="icon fill" formControlName="theftLoss">
                    <option value=""></option>
                    @for (detail of theftDetailCauses; track detail) {
                      <option [value]="detail.value">
                        {{ detail.name }}
                      </option>
                    }</select
                  ><span class="icon-chevron-down"></span>
                  <ds-form-control-message
                    [control]="causeGroup.get('theftLoss')"
                  ></ds-form-control-message>
                </ds-form-control-container>
              </div>
            </div>
          }
          <!-- loss cause of type Weather -->
          @if (lossCause?.value === 'WEATHER') {
            <div class="row">
              <div class="column twelve pad-top-40 pad-bottom-10">
                <h4
                  class="heading-sub-section"
                  dsContent
                  [contentPath]="'claims.fnol.hailDamageTypeHeading'"
                ></h4>
              </div>
              <div class="column twelve md-five">
                <ds-form-control-container
                  labelText="Description"
                  [control]="causeGroup.get('weatherLoss')"
                >
                  <select id="weatherLoss" class="icon fill" formControlName="weatherLoss">
                    <option value=""></option>
                    @for (detail of weatherDetailCauses; track detail) {
                      <option [value]="detail.value">
                        {{ detail.name }}
                      </option>
                    }</select
                  ><span class="icon-chevron-down"></span>
                  <ds-form-control-message
                    [control]="causeGroup.get('weatherLoss')"
                  ></ds-form-control-message>
                </ds-form-control-container>
              </div>
            </div>
          }
          <div class="row callToAction">
            <div class="column twelve">
              <a
                href="javascript:void(0)"
                (click)="goBackOneStep()"
                class="float-right md-float-left caption"
                ><i class="icon-chevron-left"></i> Back</a
              >
              <span class="md-float-right">
                <a
                  class="pad-horizontal-20"
                  (click)="cancel()"
                  dsContent
                  [contentPath]="'shared.cancel'"
                ></a>
                <button
                  ds-button
                  type="submit"
                  data-cy="primaryButton"
                  [disabled]="!lossCauseForm.valid"
                >
                  {{
                    !!this.draftClaim && !!this.draftClaim?.fnolDetail?.typeOfLossCauseCode
                      ? 'Update'
                      : 'Save and Continue'
                  }}
                </button>
              </span>
            </div>
          </div>
        </section>
      </form>
    }
  </div>
}
